<template>
    <div>
        <el-dialog
            :title="$t('devtable.xgqjcc')"
            :visible.sync="centerDialogVisible"
            width="980px"
            append-to-body
            center>
            <div class="schdolgfoot">
                <div class="yuang"> {{$t('devtable.yg')}}</div>
                <div class="staff">
                    <div class="staffleft">
                        <div class="stafflefttop">
                            <span style="width:80px;line-height: 32px;">{{$t('devtable.bm')}} </span>
                            <SelectSingle @handleCheckChange="handleCheckChange"></SelectSingle>
                            <!-- <el-select v-model="value" :placeholder="$t('devtable.qxz')" size="small" style="flex:4">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select> -->
                        </div>
                        <el-row  style="display: flex;padding-left:55px">
                            <el-input size="small" v-model="input_name" :placeholder="$t('devtable.xm')" style="flex:3;margin-right:20px"></el-input>
                            <el-row  style="flex:2;line-height: 32px;"> <el-button type="primary" @click="searchWithName" size="small">{{$t('devtable.cx')}}</el-button></el-row>
                        </el-row>
                    </div>
                    <div class="staffright">
                        <p>{{$t('devtable.yxyg')}}</p>
                    </div>
                </div>
                <div style="padding:25px">
                    <Tablelave  ref="transTab"></Tablelave>
                </div>
            </div>
            <div class="details">
                <el-col :span="3" style="line-height: 32px;">
                    {{$t('devtable.qjlb')}}
                </el-col>
                <el-col :span="18">
                    <el-select v-model="type" :placeholder="$t('devtable.qxz')" size="small">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </div>
            <div class="details">
                <el-col :span="3" style="line-height: 32px;">
                    {{$t('devtable.ksrq')}}
                </el-col>
                <el-col :span="5">
                    <el-date-picker
                    size="small"
                    v-model="time_start"
                    type="datetime"
                    :placeholder="$t('devtable.xzrq')">
                    </el-date-picker>
                  
                </el-col>
                
            </div>
            <div class="details">
                <el-col :span="3" style="line-height: 32px;">
                    {{$t('devtable.jsrq')}}
                </el-col>
                <el-col :span="5">
                    <el-date-picker
                    size="small"
                    v-model="time_end"
                    type="datetime"
                    :placeholder="$t('devtable.xzrq')">
                    </el-date-picker>
                </el-col>
                
            </div>
            <div class="details">
                <el-col :span="3" style="line-height: 32px;">
                    {{$t('devtable.mx')}}
                </el-col>
                <el-col :span="18">
                    <el-input
                    size="small"
                    placeholder=""
                    v-model="remark"
                    clearable>
                    </el-input>
                </el-col>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handserqingj">{{$t('tablename.qd')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Tablelave from './tablelave'
import SelectSingle from '@/components/selectree/selectchoice'
import { formatDate } from '@/utils/date'
export default {
    components:{
        Tablelave,
        SelectSingle
    },
    data(){
        return{
            user_id:'',
            type:'',
            time_end:'',
            time_start:'',
            remark:'',
            value1:'',
            tableData_b:[],
            form: {
                name: '',
                date1:''
            },
            input_name:'',
            input:"",
            centerDialogVisible: false,
            datas:[] ,
            vluass:[1,4],
            options: [{
                value: '0',
                label:this.$t('devtable.sjj')
                }, {
                value: '1',
                label: this.$t('devtable.bjj')
                }, {
                value: '2',
                label: this.$t('devtable.cch')
                }, {
                value: '3',
                label: this.$t('devtable.cjj')
                }, {
                    value: '4',
                    label: this.$t('devtable.njj')
                },{
                value: '5',
                label: this.$t('devtable.hsjq')
            },{
                value: '6',
                label: this.$t('devtable.qtt')
            }],
            value: '',
            id:'',
            ryuanlist:[],
            tableData_b:[],
            UserInfo:''
        }
    },
    mounted(){
      this.UserInfo = JSON.parse(window.localStorage.getItem('user'));
    },
    methods:{
        getryuzil(item){
            this.id = item.id
            this.tableData_b=[]
            let data ={
                method:'co.person.list',
                page_index:1,
                page_size:1000, 
                name:'',
                mobile:'',
                card_no:'',
                agent_id:this.UserInfo.agent_id,
                dept_id:'',
                number:'',
            }
            this.$serve(data).then(res=>{
                this.ryuanlist = res.data.data
            }).then(res=>{
                this.getqingjryinfo(item)
            })
        },
        // 获取请假信息
        getqingjryinfo(item){
            let parmast={
                method:"att.askleave.get",
                id:item.id
            }
            this.$serve(parmast).then(res=>{
                if(res.data.code==0){
                    console.log(res.data.data)
                    var data = res.data.data
                    if(data.type==0){
                        data.type=this.$t('devtable.sjj')
                    }else if(data.type==1){
                        data.type=this.$t('devtable.bjj')
                    }else if(data.type==2){
                        data.type=this.$t('devtable.cch')
                    }else if(data.type==3){
                        data.type=this.$t('devtable.cjj')
                    }else if(data.type==4){
                        data.type=this.$t('devtable.njj')
                    }else if(data.type==5){
                        data.type=this.$t('devtable.hsjq')
                    }else {
                        data.type=this.$t('devtable.qt')
                    }
                    this.type=data.type
                    this.time_start = formatDate(new Date(data.time_start*1000), 'yyyy-MM-dd')
                    this.time_end = formatDate(new Date(data.time_end*1000), 'yyyy-MM-dd')
                    this.remark = data.remark
                    // console.log(userId)
                    // var userId = data.user_id.split(',')
                    // userId.forEach(element=>{
                    //     this.ryuanlist.forEach(el=>{
                    //         if(element == el.id){
                    //             this.tableData_b.push(el)
                    //         }
                    //     })
                    // })
                    this.ryuanlist.forEach(el=>{
                        if(el.id == data.user_id){
                            this.tableData_b.push(el)
                            this.$refs.transTab.tableData_b= this.tableData_b
                            // console.log(this.tableData_b)
                        }
                    })
                   
                }
            })
        },
        // 修改请假
        handserqingj(){
            let userId=[]
            this.$refs.transTab.tableData_b.forEach(el=>{
                console.log(el)
                userId.push(el.id)
            })
            if(userId.length == 0){
                this.$message({
                    type: 'warning',
                    message:this.$t('devtable.qxzyg')
                })
                return false;
            }
            let parmast={
                id : this.id,
                method:'att.askleave.edit',
                agent_id:this.UserInfo.agent_id,
                user_id:userId.toString(),
                type:this.type,
                time_start:Math.round(new Date(this.time_start) / 1000),
                time_end:Math.round(new Date(this.time_end) / 1000),
                remark:this.remark
            }
            this.$serve(parmast).then(res=>{
                console.log(res)
                if(res.data.code == 0){
                    this.$message({
                        type: 'success',
                        message: this.$t('devtable.xgcg')
                    })
                    this.centerDialogVisible = false;
                    this.$parent.getqingjrylist()
                }else{
                    this.$message({
                        type: 'error',
                        message: this.$t('devtable.xgsb')
                    })                    
                }
            })
        },
        handleCheckChange(sel_dept){
            console.log(sel_dept);
            this.dept_id = sel_dept;
            this.$refs.transTab.getEmployeeListWithDept(sel_dept,this.input_name);
        },
        // 
        searchWithName(){
            if(this.input_name.length == 0){
                this.$message({
                    type: 'warning',
                    message:this.$t('devtable.qsrygxm')
                })
            }else if(this.dept_id.length == 0){
                this.$message({
                    type: 'warning',
                    message: this.$t('devtable.qxxzbm')
                })
            }else{
                this.$refs.transTab.getEmployeeListWithDept(this.dept_id,this.input_name);
            }
        },
        
    }
}
</script>
<style lang="less" scoped>
.schdolgfoot{
    border: 1px solid #ccc;
    position: relative;
    height: 435px;
    margin-top: 20px;
    .yuang{
        width: 50px;
        height: 20px;
        text-align: center;
        background-color: #fff;
        position: absolute;
        top:-10px;
        left: 20px;
    }
    .staff{
        display: flex;
        padding: 20px;
        .staffleft{
            flex: 1;
            .stafflefttop{
                display: flex;
                margin-bottom: 20px;
                margin-left: 10px;
            }
        }
        .staffright{
            flex: 1;
            p{
                text-align: center;
            }
        }
    }
}
.details{
    padding: 25px;
}
.line{
    text-align: center;
    line-height: 30px;
}
</style>